import BlogTable from "./components/BlogTable";

const Tables = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <BlogTable />
      </div>
    </div>
  );
};

export default Tables;
